export const DashboardRoutesList = {
  MERCHANT_ROUTE: 'merchant',
  PAYMENT_ROUTE: 'payment',
  PAYOUT_ROUTE: 'payout',
  SETTINGS_ROUTE: 'settings',
  VIRTUAL_TERMINAL_ROUTE: 'virtual-terminal',
};

export default DashboardRoutesList;
